export const lightTheme = {
  colors: {
    //Background
    background: 'white',
    secondary: '#007575',
    navBackground: '#FAF9F6',

    //Text
    inputFocus: '#009696',
    inputBorder: '#696969',
    textColor: 'black',
    navText: 'black',
    diagnosticBackground: '#999999',
    errorText: 'red',

    //Copy
    copyBackground: '#737373',
    copyText: 'white',

    //Table
    tableHead: '#eef0f3',
    tableCell: '#00a693',
    emptyCell: '#eef0f3',
    tableBorder: '#454545',
    tableText: 'black',
    tableCellActive: '#00bfa9',

    //Button
    buttonBackground: '#dcdee0',
    buttonHover: '#ededed',

    //Alternate Button
    altButtonInitial: '#696969',
    altButtonHover: '#00a693',
    altButtonText: 'white',
    altButtonTextHover: 'black',
    altButtonLoading: '#008787',
    
    //Forms Page
    patientInfo:'#00a693',
    patientInfoText: 'black',
    patientInfoHover:'#00c2ac',
    pageBreak:'rgba(0,0,0,.5)',

    //Tabs
    tabBorder:'#007575',
    tabBackground:'#aaabad',

    //Triage Key
    mild:'#00ed1c',
    moderate:'#e8e802',
    high:'rgb(255, 140, 1)',
    urgent:'rgb(237, 41, 56)',

    //Patient Forms
    patientFormText: 'black',
    patientFormHead: '#aaabad',
    patientFormEven: '#eef0f3',
    patientFormOdd: '#dedfe0',
    patientFormBorder: '#434343',
    patientFormTextArea: '#696969',

    //Scroll Bar
    trackColor: '#a1a1a1',
    thumbColor: '#7d7d7d',

    //Select
    selectBackground:'#9e9e9e',
    selectHover:'#858585',
  },
  fontSizes: {
    small: "1em",
  }
};

export const darkTheme = {
  colors: {
    //Background
    background: '#181a1b',
    secondary: '#007575',
    navBackground: '#101010',

    //Text
    inputFocus: '#001f1f',
    inputBorder: '#696969',
    textColor: 'white',
    navText: 'white',
    diagnosticBackground: '#171717',
    errorText: 'red',

    //Copy
    copyBackground: '#171717',
    copyText: 'white',

    //Table
    tableHead: '#161616',
    tableCell: '#013538',
    emptyCell: '#181a1b',
    tableBorder: '#292a29',
    tableText: 'white',
    tableCellActive:'#007575',

    //Button
    buttonBackground: '#2d2d2d',
    buttonHover: '#4f4f4f',

    //Alternate Button
    altButtonInitial: '#292929',
    altButtonHover: '#007575',
    altButtonText: 'white',
    altButtonTextHover: 'black',
    altButtonLoading: '#008787',

    //Forms Page
    patientInfo:'#013538',
    patientInfoHover:'#015459',
    patientInfoText: 'white',
    pageBreak:'rgba(255,255,255,.25)',

    //Tabs
    tabBorder:'#007575',
    tabBackground:'#171717',

    //Triage Key
    mild:'rgb(45,201,55)',
    moderate:'rgb(231,180,22)',
    high:'rgb(219,123,43)',
    urgent:'rgb(204,50,50)',

    //Patient Forms
    patientFormText: 'white',
    patientFormHead: '#161616',
    patientFormEven: 'rgb(54, 54, 54)',
    patientFormOdd: 'rgb(44, 44, 44)',
    patientFormBorder: '#434343',
    patientFormTextArea: 'black',

    //Scroll Bar
    trackColor: '#1f2223',
    thumbColor: '#454a4d',

    //Select
    selectBackground:'#242424',
    selectHover:'#525252',
  },
  fontSizes: {
    small: "1em",
  }
};